module.exports = __webpack_public_path__ + "static/img/loginbg.3d680bf.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/loginbg.png
// module id = EdE9
// module chunks = 1